import * as PIXI from "pixi.js";
import gsap from "gsap";
import MyApplication from "../../../pixi/MyApplication";
import AssetsManager from "../../../pixi/AssetsManager";

/**
 * ReadyTextViewクラス
 */
class ReadyTextView extends PIXI.Container {
  // ---------------------------------------------------------------------------------------------------------
  // --	VARS
  // ---------------------------------------------------------------------------------------------------------

  //ムービークリップ
  private _mc: PIXI.AnimatedSprite;

  // ---------------------------------------------------------------------------------------------------------
  // --	ReadyTextView
  // ---------------------------------------------------------------------------------------------------------

  /**
   * コンストラクタ
   */
  constructor() {
    super();

    //ムービークリップ
    this._mc = AssetsManager.instance.createMovieClipFromAnimation(
      "ready",
      false
    );
    this._mc.anchor.set(0.5);
    this._mc.scale.set(4);
    this._mc.animationSpeed = 1;
    this.addChild(this._mc);

    //リセット
    this.reset();
  }

  reset(): void {
    //アニメーション停止
    this._mc.stop();

    //位置
    this.x = MyApplication.screenWidth + this.width / 2;
  }

  open(): void {
    //点滅
    this._mc.play();

    //アニメーション
    gsap.to(this, {
      duration: 0.25,
      x: MyApplication.screenWidth / 2,
      ease: "back.out(1.7)",
    });
  }

  close(): void {
    //アニメーション
    gsap.to(this, {
      duration: 0.25,
      x: -this.width / 2,
      ease: "back.in(1.7)",
      onComplete: this.reset.bind(this),
    });
  }

  // ---------------------------------------------------------------------------------------------------------
}

export default ReadyTextView;
